export enum FraudStatus {
	None = 0,
	Processing = 1,
	Approved = 2,
	Deny = 3,
	WaitingManuallyApproval = 4,
	WaitingCreate = 5,
	Error = 6,
}
